/**
 * Admin Redux thunk actions — M5 Admin Console.
 * Follows the identical pattern as subscriptionActions.js.
 */
import { ADMIN_ACTION_TYPES } from '../reducers/adminReducer';
import * as adminService from '../../services/adminService';

export const clearAdmin = () => ({ type: ADMIN_ACTION_TYPES.CLEAR });

// ─── Stats ────────────────────────────────────────────────────────────────────

export const loadAdminStats = () => async (dispatch) => {
  dispatch({ type: ADMIN_ACTION_TYPES.SET_LOADING, payload: true });
  try {
    const data = await adminService.fetchStats();
    dispatch({ type: ADMIN_ACTION_TYPES.SET_STATS, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: ADMIN_ACTION_TYPES.SET_ERROR, payload: e.message });
    throw e;
  }
};

// ─── Users ────────────────────────────────────────────────────────────────────

export const loadAdminUsers = (page = 1, limit) => async (dispatch) => {
  dispatch({ type: ADMIN_ACTION_TYPES.SET_LOADING, payload: true });
  try {
    const data = await adminService.fetchUsers(page, limit);
    dispatch({ type: ADMIN_ACTION_TYPES.SET_USERS, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: ADMIN_ACTION_TYPES.SET_ERROR, payload: e.message });
    throw e;
  }
};

// ─── Role change ──────────────────────────────────────────────────────────────

export const changeUserRole = (userId, role) => async (dispatch) => {
  dispatch({ type: ADMIN_ACTION_TYPES.SET_LOADING, payload: true });
  try {
    const data = await adminService.updateUserRole(userId, role);
    // Merge updated role back into the cached user list
    dispatch({
      type: ADMIN_ACTION_TYPES.UPDATE_USER,
      payload: { id: userId, role: data.role },
    });
    return data;
  } catch (e) {
    dispatch({ type: ADMIN_ACTION_TYPES.SET_ERROR, payload: e.message });
    throw e;
  }
};

// ─── Subscription override ────────────────────────────────────────────────────

export const changeUserSubscription = (userId, fields) => async (dispatch) => {
  dispatch({ type: ADMIN_ACTION_TYPES.SET_LOADING, payload: true });
  try {
    const data = await adminService.updateUserSubscription(userId, fields);
    dispatch({
      type: ADMIN_ACTION_TYPES.UPDATE_USER,
      payload: {
        id: userId,
        subscription: {
          status: data.status,
          planCode: data.planCode || null,
        },
      },
    });
    return data;
  } catch (e) {
    dispatch({ type: ADMIN_ACTION_TYPES.SET_ERROR, payload: e.message });
    throw e;
  }
};

// ─── Account status ───────────────────────────────────────────────────────────

export const changeUserAccount = (userId, accountStatus, reason) => async (dispatch) => {
  dispatch({ type: ADMIN_ACTION_TYPES.SET_LOADING, payload: true });
  try {
    const data = await adminService.updateUserAccount(userId, accountStatus, reason);
    dispatch({
      type: ADMIN_ACTION_TYPES.UPDATE_USER,
      payload: {
        id: userId,
        accountStatus: data.accountStatus,
        accountStatusReason: data.accountStatusReason || null,
      },
    });
    return data;
  } catch (e) {
    dispatch({ type: ADMIN_ACTION_TYPES.SET_ERROR, payload: e.message });
    throw e;
  }
};
